import React from 'react';
import WdmPng from './logo-pngs/WDM_Logo_CLR.png';

export default class WdmLogo extends React.Component {
    render() {
        return (
            <div className="brand-logo">
                <svg
                    viewBox="0 0 374 134"
                    role="img"
                    aria-label="WDM Pumps logo"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <image
                        href={WdmPng}
                        x="0"
                        y="0"
                        width="374"
                        height="134"
                        preserveAspectRatio="xMidYMid slice"
                    />
                </svg>
            </div>
        );
    }
}